import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CodeLangStateService } from '../services/code-lang-state.service';
import { isSupportedCodeLang } from '../domain/code-gen/code-lang.utils';
import { SupportedCodeLang } from '../domain/code-gen/code-lang.types';
import { DEFAULT_CODE_LANG } from '../domain/code-gen/code-lang.config';

@Injectable({ providedIn: 'root' })
export class CodeLangResolver implements Resolve<SupportedCodeLang> {
  constructor(private codeLangState: CodeLangStateService) {}

  resolve(route: ActivatedRouteSnapshot): SupportedCodeLang {
    const codeLang = route.queryParamMap.get('codeLang');
    const resolvedCodeLang = (codeLang && isSupportedCodeLang(codeLang)) ? codeLang : DEFAULT_CODE_LANG;
    this.codeLangState.setCodeLang(resolvedCodeLang);
    return resolvedCodeLang;
  }
}
